import { Routes } from '@angular/router';
import { preLoginRoutes } from './pages/pre-login/pre-login.routes';
import { protectedRoutes } from './pages/protected/protected.routes';

export const routes: Routes = [

    ...preLoginRoutes,
    ...protectedRoutes,

    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'protected',
    },

    {
        path: '**',
        loadComponent: () => import('./pages/pre-login/not-found/not-found').then(m => m.NotFoundComponent),

    },

];
